export default __webpack_public_path__ + "static/media/logo.bad14865.png";